import { render, staticRenderFns } from "./VideoOnDemand.vue?vue&type=template&id=7a9da45b&scoped=true"
import script from "./VideoOnDemand.vue?vue&type=script&lang=js"
export * from "./VideoOnDemand.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./VideoOnDemand.vue?vue&type=style&index=1&id=7a9da45b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9da45b",
  null
  
)

export default component.exports